function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 1.4375rem;\n  top: 1.5rem;\n  left: 1rem;\n  background: ", ";\n  border-radius: ", ";\n  position: absolute;\n  display: block;\n  height: 0.125rem;\n  cursor: pointer;\n  content: '';\n\n  &::before,\n  &::after {\n    background: ", ";\n    width: 1.4375rem;\n    height: 0.125rem;\n    border-radius: ", ";\n    position: absolute;\n    display: block;\n    cursor: pointer;\n    content: '';\n  }\n\n  &::before {\n    top: 0.4375rem;\n  }\n\n  &::after {\n    top: -0.4375rem;\n  }\n\n  &.header__nav-toggle__content--opened {\n    background-color: transparent;\n\n    &::before,\n    &::after {\n      top: 0;\n    }\n\n    &::before {\n      transform: rotate(45deg);\n    }\n\n    &::after {\n      transform: rotate(-45deg);\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 3.125rem;\n  height: 3.125rem;\n  padding: 0;\n  cursor: pointer;\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled from "../../../theme";
export var HeaderNavToggleWrapper = styled.div(_templateObject());
export var HeaderNavToggleContent = styled.span(_templateObject2(), function (props) {
  return props.theme.variables.customColors.leadingColor.base;
}, function (props) {
  return props.theme.variables.borders.width.base;
}, function (props) {
  return props.theme.variables.customColors.leadingColor.base;
}, function (props) {
  return props.theme.variables.borders.width.base;
});